import { useEffect } from "react";
import { useInput } from "hooks";
import { DecimalInput } from "components";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveCouponTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const val = useInput("");

  const handleUpdateValue = (v) => {
    onChange(`Receive $${formatDollarValue(v)} in Coupons`);
  };

  useEffect(() => {
    if (value.startsWith("Receive $")) {
      const mainPart = value.slice(9).replace(" in Coupons", "").trim();
      val.setValue(mainPart);
    }
    return () => { };
  }, [value]);

  return (
    <div className="p-2 d-flex justify-content-between align-items-center">
      <div className="mt-2 w-100">Receive $ Coupons</div>

      <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '96%' }}
        value={val.value}
        onChange={(e) => {
          val.setValue(e);
          handleUpdateValue(e);
        }}
      />
    </div>
  );
};